
// src/connects/user-block-panel.js

import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import actions from '../actions'
import lifecycle from '../helpers/lifecycle'
import combineHOC from '../helpers/combine-hoc'
import context from '../helpers/context'
import { emitAlertMessage } from '../actions/alert-message'

export const mapStateToProps = (state)=> {
  return {
    current: state.user.current,
    blockUsers: state.block.users
  }
}

export const mapDispatchToProps = (dispatch)=> {
  return {
    updateBlockUser: (user, block)=> {
      dispatch(actions.updateBlockUser(user.user_id, block))
      dispatch(emitAlertMessage({ message: 'label:ユーザをブロック解除しました', name: user.name }, 'success'))
    },
    onClose: () => {
      dispatch(actions.closeUserSettingsPage())
    }
  }
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps),
  context({ showUserSelectionDialog: PropTypes.func }),
  lifecycle,
  translate(),
)



// WEBPACK FOOTER //
// ./src/connects/user-block-panel.js